import _extends from "@babel/runtime-corejs3/helpers/esm/extends";
import React from "react";
import { RadioButton } from "@xo-union/tk-component-switches";
import Icon from "@xo-union/tk-component-icons";
import unionRadioButtonStyles from "@xo-union/tk-component-switches/lib/components/RadioButton/styles.css";
import styles from "./styles.css";
import MergeUnionCss from "../../utils/merge_union_css.js";
var ColorSwitch = function ColorSwitch(props) {
  var handleChange = function handleChange(e) {
    props.onChange(e);
  };
  var handleClick = function handleClick(e) {
    if (props.checked) {
      props.onChange(e);
    }
  };
  var localStyleInfo = {
    'container': ['container'],
    'label': ['label'],
    'label-text': ['label-text'],
    'icon': ['icon', 'ease-out', "color-swatch-".concat(props.value)]
  };
  if (props.checked) {
    localStyleInfo['label'].push('is-selected');
  }
  var classes = MergeUnionCss(unionRadioButtonStyles, styles, localStyleInfo);
  var refCallback = function refCallback(el) {
    if (el) {
      el.tabIndex = props.tabIndex === -1 ? -1 : 0;
    }
  };
  return /*#__PURE__*/React.createElement(RadioButton, _extends({}, props, {
    onChange: handleChange,
    onClick: handleClick,
    classes: classes,
    ref: refCallback
  }), props.checked && /*#__PURE__*/React.createElement(Icon, {
    name: "checkmark_mini",
    size: "md",
    className: styles.checkmark,
    "aria-hidden": "true"
  }), /*#__PURE__*/React.createElement("span", {
    className: styles['label-content']
  }, props.value));
};
export default ColorSwitch;